export const updateCompany = `mutation UpdateCompany($input: UpdateCompanyInput!) {
  updateCompany(input: $input) {
    id
    ATSProcessingConfig
    name
    defaultBonusAmount
    contactIncentiveBonus
    brandColor
    accountType
    loginFormPickerSettings
    loginFormSettings
    logo {
      bucket
      region
      key
      __typename
    }
    shareLogo {
      bucket
      region
      key
      __typename
    }
    dashboardSearchBG {
      bucket
      region
      key
      __typename
    }
    websiteUrl
    sendAdminNotificationsOnReferral
    sendAdminNotificationsOnInternalCandidatesFound
    enableAcceptedReferralReminder
    referralBonusWaitingPeriod
    referralBonusNotificationRecipients
    SFTPProcessingConfig
    dashboardReferralPolicyText
    bonusEarnedNote
    allowSelfReferrals
    allowInternalMobility
    internalMobilityImage {
      bucket
      region
      key
    }
    employeeDashboard
    employeeDashboardRows
    emailSettings
    ignoreSubcompany
    enableGenericReferralEmail
    enableLead
    hideSubcompanyOnAcceptancePage
    hideSubcompanyOnSignup
    hideSubcompanyOnJobs
    sendReferralColor
    applyInternallyColor
    generalReferralColor
    referralLeadColor
    defaultLocation
    disableSmartReferrals
    disableSAMLLogin
    disableClaimYourAccountLogin
    emailSettings
    confirmContactEmails
    confirmCompliance
    ssoGoogleDomain
    theme
    symbol {
      bucket
      region
      key
      __typename
    }
    background {
      bucket
      region
      key
      __typename
    }
    errorImage {
      bucket
      region
      key
      __typename
    }
    whiteLabel
    userEditSettings
    jobFilterSettings
    stages
    enableGeneralReferrals
    enableProspectCreation
    enableRetroactiveBonuses
    enableRecognition
    disableManagerPermissions
    disableManagerPermissionsByType
    hideBonus
    enableDashboardSearch
    hideDateCreatedJobDetails
    recognitionSettings {
      allowRecognitionsForAccountClaims
      allowSelfNominations
      recognitionAnnouncementText
      recognitionCategories
      recognitionCustomTitle
      recognitionHashtags
      requireBadgeSelection
      requireBadgeAssignmentMessage
			customModal {
        title
        content
        isEnabled
        showEachLogin
			}
      hideRecognitionSocialShare
      hideRecognitionLeaderboard
      hideAllRecognitionsManager
      catalogOnlyGroupedByCategory
      customSendRecognitionBoxText
      customSendToPeerText
      disableRecHub
      disableNominations
      disableReplies
      disableReplyNotifications
      recognitionPointsCurrency
      notificationOnApprovalDecision
      allowAdminBalanceOverrides
      rewardsEarnedMechanism
      baseSnappyBudget
      nominatedRecognitionsCostPoints
      enableManagerSendForm
      requireJustification
      requireAdminApproval
      assignSnappyRewardToRecognition
      tieredRewardsCampaign {
        id
        name
        description
        snappyGrantId
        snappyGrant {
						id
						externalSnappyId
						snappyCampaignId
						name
						description
						costInCurrency
					}
        unlockConditionType
        unlockConditionAmount
			}
      milestoneColorMap {
        years
        color
      }
      milestoneClaimExpiryDays
      milestoneClaimModalTitle
      milestoneClaimModalMessage
    }
    referralStatus
    referralCustomStatuses
    requireBonusChangeReason
    allowSelfReferralsInternalLink
    disableReferrals
    automationSettings
    platformConfig
    ownershipSettings
    bonusReportSetting
    includeAdminInRanking
    senderEmailAddress
    whiteLabelServiceName
    eligibiltyChecks
    enableCustomDashboard
    enableCustomNav
    customNav
		customDashboard
    publicLeaderboard
    hideReferralsRanking
    giftCardStoreAPIKeys {
      apiKey
      region
    }
    giftCardStoreBalance
    giftCardStorePendingBalance
    pointsSettings
    popupTitle
    popupTitleContent
    hideWhatsApp
    defaultToSubcompany
    hideMessageRecruiter
    hidePaymentInfoJobCard
    hideRecruiterInfo
    hideRecruiterInfoJobDetails
    showRecruiterInfoJobCard
    internalMobilityCustomTitle
    appStoreUrls{
      ios
      android
    }
    onboarding
    partnerBillingPolicy
    partnerClientId
    partnerHostId
    payBonusesWithPoints
    preStartEnabled
	  preStartUserGroupId
    enableReferralNetworkShare
    referralNetworkShareOptions
    enableAppReview
    referralsReportFrequency
    referralsReportDateRange
    employeeReportFrequency
    bonusReportFrequency
    countryCode
    analyticsCardInputValues
    customText
    metabaseReports {
      id
      label
      reportId
      reportType
    }
  }
}
`;
